import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/Projects';
import Breadcrumb from '../components/AdminBreadcrumb';
import GridHeader from '../components/common/GridHeader';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import { DataGrid } from '@mui/x-data-grid';

const Projects = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);

    useEffect(() => {
        props.actions.getProjects();
    }, []);

    const handleSelect = (e) => {
        props.actions.getProject(e.id);
        props.history.push(`/projects/project/${e.id}`, { id: e.id })
    };

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.projects.filter(x => e.find(y => y === x.get('projectId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const handleCreate = () => {
        props.actions.newProject();
        props.history.push('/projects/project');
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleDelete = () => {
        props.actions.deleteProjects(deleteConfirmationState.toDelete.map(x => x.projectId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    return (
        <Container>
            <div style={{ paddingBottom: '10px' }}>
                <Breadcrumb history={props.history} />
            </div>
            <Row className='mb-1'>
                <GridHeader
                    gridEntities='Projects'
                    deleteButtonId='deleteProjectButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addProjectButton'
                    onAddClick={handleCreate}
                    addTooltipTarget={'addProjectButton'}
                    deleteTooltipTarget={'deleteProjectButton'}
                    tooltipEntity={'Project'}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.projects.toJS().map(x => { return { id: x.projectId, ...x } })}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Name',
                                    field: 'name',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Code',
                                    field: 'code',
                                    flex: 3,
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'} />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete Projects`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => x.name)}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );
}

function mapStateToProps(state, ownProps) {
    return {
        projects: state.Projects
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Projects);